module.exports = __webpack_public_path__ + "Roboto-700.128879da78c6c8eb4e2c.eot";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.eot
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.eot
// module chunks = main styles